function isEmptyValue(value: any): boolean {
    if (value === null || value === undefined) {
      return true;
    }
  
    if (isDate(value)) {
      return false;
    }
  
    if (typeof value === "string") {
      return value.trim() === "";
    }
  
    if (Array.isArray(value)) {
      return value.length === 0;
    }
  
    if (typeof value === "object") {
      return Object.keys(value).length === 0;
    }
  
    return false;
  }
  
  function isDate(value: any): boolean {
    if (value instanceof Date) {
      return !isNaN(value.getTime());
    }
  
    if (typeof value === "string") {
      const parsedDate = new Date(value);
      return !isNaN(parsedDate.getTime());
    }
  
    return false;
  }
  
  export function cleanObject<T>(obj: T): T extends any[] ? T : Partial<T> {
    if (Array.isArray(obj)) {
      const cleanArray = obj
        .map((item) =>
          typeof item === "object" && item !== null
            ? cleanObject(item)
            : isEmptyValue(item)
            ? undefined
            : item
        )
        .filter((item): item is NonNullable<typeof item> => !isEmptyValue(item));
  
      return (cleanArray.length ? cleanArray : undefined) as T extends any[]
        ? T
        : Partial<T>;
    }
  
    const cleaned: Partial<T> = {};
  
    for (const [key, value] of Object.entries(obj as object)) {
      if (typeof value === "object" && value !== null && !isDate(value)) {
        const cleanedValue = cleanObject(value);
        if (!isEmptyValue(cleanedValue)) {
          cleaned[key as keyof T] = cleanedValue as any;
        }
      } else if (!isEmptyValue(value)) {
        cleaned[key as keyof T] = value;
      }
    }
  
    return (Object.keys(cleaned).length ? cleaned : undefined) as T extends any[]
      ? T
      : Partial<T>;
  }